import { Post } from "@/types/post";

// Per-tab in-memory cache keyed by post id. Producers of Post objects (feeds,
// group screen, navigation call sites) write into it so PostDetailsScreen can
// paint instantly when the user has already seen the post — URL entry falls
// through to fetchPost as before. Cap matches PostsContext.MAX_POSTS_IN_MEMORY
// so steady-state memory stays comparable to today.
const CAP = 50;
const store = new Map<string, Post>();

export function cachePost(post: Post | null | undefined): void {
  if (!post?.id) return;
  if (store.has(post.id)) store.delete(post.id);
  store.set(post.id, post);
  if (store.size > CAP) {
    const oldest = store.keys().next().value;
    if (oldest !== undefined) store.delete(oldest);
  }
}

export function cachePosts(posts: readonly (Post | null | undefined)[]): void {
  for (const p of posts) cachePost(p);
}

export function getCachedPost(id: string | undefined): Post | undefined {
  if (!id) return undefined;
  const hit = store.get(id);
  if (!hit) return undefined;
  store.delete(id);
  store.set(id, hit);
  return hit;
}

export function clearPostCache(): void {
  store.clear();
}
